import React from "react"
import { Row, Col, Button } from "reactstrap"
import { connect } from "react-redux"
import { Link } from "react-router-dom"


const Breadcrumb = props => {
  const itemLength = (props.breadcrumbItems || []).length || 1

  return (
    <Row className="d-flex justify-content-end">
      <Col sm={10}>
        <div className="page-title-box">
          <h4>{props.title}</h4>
          <ol className="breadcrumb m-0">
            {(props.breadcrumbItems || []).map((item, key) =>
              key + 1 === itemLength ? (
                <li key={key} className="breadcrumb-item active">
                  {item.title}
                </li>
              ) : (
                <li key={key} className="breadcrumb-item">
                  <Link to="#">{item.title}</Link>
                </li>
              ),
            )}
          </ol>
        </div>
      </Col>

      <Col sm={2} class="d-flex justify-content-center">
        <Button
          type="button"
          color="primary"
          className="waves-effect waves-light"
        >
          Primary
        </Button>
      </Col>
    </Row>
  )
}

const mapStatetoProps = state => {
  const Layout = state.Layout
  const BreadcrumbData = state.Breadcrumb
  return {
    layoutType: Layout.layoutType,
    title: BreadcrumbData.title,
    breadcrumbItems: BreadcrumbData.breadcrumbItems,
  }
}

export default connect(mapStatetoProps, {})(Breadcrumb)
